import React, {useState, useEffect} from 'react';
import ModalPassword from '../shared/modals/modalPassword'
import { axiosInstance } from '../../client/index.tsx';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/auth/index.jsx';
import { getUserByEmail } from '../../client/users/index.tsx';
import ModalAlertWarning from '../shared/modals/modalAlertWarning/index.jsx';
import { postUserSupplierAdherence } from '../../client/userAdherence/index.tsx';
import { PERMISSION_MAPPING, hasPermission } from '../../context/permissionsMapping/index.js';
import { MODALS, LOGIN } from '../../config/images/index.js';
const FormLogin = ({ isOpen, onClose}) => {

  const {login, permissions} = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userData, setUserData] = useState(null);
  const [showTerms, setShowTerms] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isEmailExists, setIsEmailExists] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(true);
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState(''); 

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  useEffect(() => {
    const checkUserTerms = async () => {
      if (email && email.includes('@')) {
        try {
          const response = await getUserByEmail(email);
          if (response.data) {
            setUserData(response.data);
            const hasAcceptedTerms = response.data.terms_conditions === true;
            setShowTerms(!hasAcceptedTerms);
            if (hasAcceptedTerms) setTermsChecked(true);
          }
        } catch (error) {
          console.error('Error al verificar usuario:', error);
          setShowTerms(true);
          setUserData(null);
          setTermsChecked(false);
        }
      } else {
        setShowTerms(true);
        setUserData(null);
        setTermsChecked(false);
      }
    };

    const debounceTimer = setTimeout(() => {
      checkUserTerms();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [email]);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    const isValid = validateEmail(emailValue);
    setIsEmailValid(isValid);

    setEmailErrorMessage(isValid ? '' : 'Ingrese un correo electrónico válido');
    setIsEmailExists(true);
  };

  const handlePasswordChange = (e) => {
    const passwordValue = e.target.value;
    setPassword(passwordValue);
    setPasswordErrorMessage('');
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (isLoading) return;

    setIsSubmitAttempted(true);
    setIsLoading(true);

    if (showTerms && !termsChecked) {
        setIsLoading(false);
        setAlertMessage('Debe aceptar los términos y condiciones para poder iniciar sesión.');
        setShowAlertModal(true);
        return;
    }

    if (!email || !password) {
        setIsLoading(false);
        setAlertMessage('Por favor, complete todos los campos obligatorios.');
        setShowAlertModal(true);
        return;
    }

    try {
        const termsToSend = showTerms ? termsChecked : true;
        const response = await axiosInstance.post('User/Login', {
        email: email,
        password: password,
        terms_conditions: termsToSend,
        });
        
        const token = response.data.token; 
        
        if (token) {
        login(
            response.data.userId,
            token,
            response.data.userId.supplierId,            
            response.data.userId.supplierName,          
            response.data.userId.category_supplier,     
            response.data.userId.supplierCode,          
            response.data.userId.supplierCriticity,
            response.data.userId.roleId 
        );
        
        try {
            await postUserSupplierAdherence(response.data.userId.id, 0); 
            await axiosInstance.put(`Supplier/GetSupplierData/${response.data.userId.supplierCode}`);
        } catch (error) {
            console.error('Error inesperado:', error);
        }
        
        redirectBasedOnPermissions(response.data.userId.permissions);
        }
    } catch (error) {
        console.error('Error en el inicio de sesión:', error);

        if (error.response && error.response.status === 429) { 
        setAlertMessage('Has superado el número máximo de intentos. Inténtalo de nuevo en unos momentos.');
        setShowAlertModal(true);
        setIsLoading(false);
        return;
        }
        
        if (error.response && error.response.data && error.response.data.message) {
        setAlertMessage(error.response.data.message);
        setShowAlertModal(true);
        } else {
        setAlertMessage('Error en el inicio de sesión. Por favor, inténtelo de nuevo.');
        setShowAlertModal(true);
        }
    } finally {
        setIsLoading(false);
    }
};

 const redirectBasedOnPermissions = (userPermissions) => {
    // Si tiene permiso para el dashboard, redirigir allí
    if (hasPermission(userPermissions, 16) || hasPermission(userPermissions, 23)) {
      navigate('/inicio');
      return;
    }
    
    // Buscar la primera ruta disponible basada en permisos
    const availableRoutes = [];
    
    userPermissions.forEach(permission => {
      const permissionConfig = PERMISSION_MAPPING[permission.id];
      if (permissionConfig) {
        if (permissionConfig.path) {
          availableRoutes.push(permissionConfig.path);
        } else if (permissionConfig.subMenu) {
          permissionConfig.subMenu.forEach(subItem => {
            if (subItem.path) {
              availableRoutes.push(subItem.path);
            }
          });
        }
      }
    });
    
    // Redirigir a la primera ruta disponible o a una por defecto
    if (availableRoutes.length > 0) {
      navigate(availableRoutes[0]);
    } else {
      setAlertMessage('No tiene permisos para acceder a ninguna sección. Contacte al administrador.');
      setShowAlertModal(true);
    }
  };

  const isFormValid = email && password && (showTerms ? termsChecked : true);

  if (!isOpen) return null;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center py-14">
        <div className="lg:w-1/3 sm:w-1/2 w-[90%] p-6 h-auto bg-white flex flex-col justify-center rounded-[29px] drop-shadow-custom">
            <button 
                className="absolute p-2 text-black top-4 right-4"
                onClick={onClose} 
            >
                <img src={MODALS.CLOSE} alt="cerrar"/>
            </button>
            <form onSubmit={handleSubmit} className="flex flex-col items-center w-full h-full gap-2 overflow-y-auto">
                <h1 className='pt-2 text-3xl sm:text-2xl  md:text-5xl xl:text-6xl pb-7 font-itcbold text-[#184A7D]'>
                    ConecTASA
                </h1>
                <p  className="md:text-[20px] text-sm text-blue font-itcbold">
                    Ingresa tus credenciales
                </p>
                <p className="text-gray font-itcbook md:text-[15px] text-xs">
                    Ingresa escribiendo tu correo y contraseña
                </p>
                <div className="relative w-full">
                    <div className="absolute inset-y-0 flex items-center pointer-events-none left-4">
                        <img src={LOGIN.EMAIL} alt="email" className='w-full'/>
                    </div>
                    <input 
                        type="email"
                        disabled={isLoading}
                        value={email}
                        onChange={handleEmailChange} 
                        className={`w-full focus:outline-none h-auto py-3 placeholder:text-black md:placeholder:text-[15px] md:text-[15px] text-sm placeholder:text-sm font-itcbook bg-[#EFF8FD] rounded-2xl px-12`}
                        placeholder="Correo *"
                    />
                </div>

                <div className="relative w-full mt-2">
                    <div className="absolute inset-y-0 flex items-center pointer-events-none left-4">
                        <img src={LOGIN.PADLOCK} />
                    </div>
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        disabled={isLoading}
                        onChange={handlePasswordChange} 
                        className={`w-full focus:outline-none h-auto py-3 placeholder:text-black md:placeholder:text-[15px] md:text-[15px] text-sm placeholder:text-sm  font-itcbook bg-[#EFF8FD] rounded-2xl pl-12 pr-10`}
                        placeholder="Contraseña *"
                    />

                    <span 
                        className="absolute inset-y-0 flex items-center cursor-pointer right-4"
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? (
                            <img src={LOGIN.EYE_OPEN} />
                            ) : (
                            <img src={LOGIN.EYE_CLOSE}/>
                        )}
                    </span>                   
                </div>

                <p onClick={openModal}
                className="mb-5 text-xs cursor-pointer md:text-sm text-blue font-itcbook">
                    ¿Olvidaste tu contraseña?
                </p>

                {showTerms && (
                <div className="flex items-center gap-2 text-sm font-itcbook">
                    <input 
                        type="checkbox" 
                        disabled={isLoading}
                        id="terms" 
                        className="w-4 h-4 rounded text-red " 
                        checked={termsChecked}
                        onChange={(e) => setTermsChecked(e.target.checked)}
                    />
                    <label htmlFor="terms" className="text-sm text-gray">
                        Acepto el tratamiento interno de mis datos por TASA
                    </label>
                </div>
                )}
                <button 
                type= "submit"
                className={`bg-[#184A7D] w-[60%] h-[40px] rounded-lg text-sm mt-1 font-itcdemi flex justify-center items-center text-white
                    ${!isFormValid ? 'bg-[#D1D5DB] cursor-not-allowed' : ''}`}
                disabled={!isFormValid || isLoading}
                onClick={handleSubmit}
                >
                    {isLoading ? 'Ingresando...' : 'Ingresar'}
                </button>                
            </form>
        </div>
        <ModalPassword showModalPassword={isModalOpen} closeModal={closeModal} />
        <ModalAlertWarning 
            showModalAlertWarning={showAlertModal} 
            closeModal={() => setShowAlertModal(false)} 
            error={alertMessage}
        />
    </div>
  );
};
export default FormLogin;
